export const languages = {
    ar: { name: 'Arabic', slug: 'arabic', code: 'ar', label: 'عربي' },
    bg: {
        name: 'Bulgarian',
        slug: 'bulgarian',
        code: 'bg',
        label: 'Български',
    },
    ca: { name: 'Catalan', slug: 'catalan', code: 'ca', label: 'Català' },
    'zh-cn': {
        name: 'Chinese (simplified)',
        slug: 'chinese',
        code: 'zh-cn',
        label: '中文 (简体)',
    },
    'zh-tw': {
        name: 'Chinese (traditional)',
        slug: 'chinese',
        code: 'zh-tw',
        label: '中文 (繁體)',
    },
    hr: { name: 'Croatian', slug: 'croatian', code: 'hr', label: 'Hrvatski' },
    cs: { name: 'Czech', slug: 'czech', code: 'cs', label: 'Čeština' },
    da: { name: 'Danish', slug: 'danish', code: 'da', label: 'Dansk' },
    nl: { name: 'Dutch', slug: 'dutch', code: 'nl', label: 'Nederlands' },
    en: { name: 'English', slug: 'english', code: 'en', label: 'English' },
    et: { name: 'Estonian', slug: 'estonian', code: 'et', label: 'Eesti' },
    tl: { name: 'Filipino', slug: 'filipino', code: 'tl', label: 'Filipino' },
    fi: { name: 'Finnish', slug: 'finnish', code: 'fi', label: 'Suomi' },
    fr: { name: 'French', slug: 'french', code: 'fr', label: 'Français' },
    de: { name: 'German', slug: 'german', code: 'de', label: 'Deutsch' },
    el: { name: 'Greek', slug: 'greek', code: 'el', label: 'Ελληνικά' },
    iw: { name: 'Hebrew', slug: 'hebrew', code: 'iw', label: 'עברית' },
    hi: { name: 'Hindi', slug: 'hindi', code: 'hi', label: 'हिन्दी' },
    hu: { name: 'Hungarian', slug: 'hungarian', code: 'hu', label: 'Magyar' },
    is: { name: 'Icelandic', slug: 'icelandic', code: 'is', label: 'Íslenska' },
    id: {
        name: 'Indonesian',
        slug: 'indonesian',
        code: 'id',
        label: 'Indonesia',
    },
    it: { name: 'Italian', slug: 'italian', code: 'it', label: 'Italiano' },
    ja: { name: 'Japanese', slug: 'japanese', code: 'ja', label: '日本語' },
    ko: { name: 'Korean', slug: 'korean', code: 'ko', label: '한국어' },
    lv: { name: 'Latvian', slug: 'latvian', code: 'lv', label: 'Latviešu' },
    lt: {
        name: 'Lithuanian',
        slug: 'lithuanian',
        code: 'lt',
        label: 'Lietuvių',
    },
    ms: { name: 'Malay', slug: 'malay', code: 'ms', label: 'Melayu' },
    no: { name: 'Norwegian', slug: 'norwegian', code: 'no', label: 'Norsk' },
    fa: { name: 'Persian', slug: 'persian', code: 'fa', label: 'فارسی' },
    pl: { name: 'Polish', slug: 'polish', code: 'pl', label: 'Polski' },
    pt: {
        name: 'Portuguese',
        slug: 'portuguese',
        code: 'pt',
        label: 'Português',
    },
    'pt-br': {
        name: 'Portuguese (Brazil)',
        slug: 'portuguese-brazilian',
        code: 'pt-br',
        label: 'Português (Brasil)',
    },
    ro: { name: 'Romanian', slug: 'romanian', code: 'ro', label: 'Română' },
    ru: { name: 'Russian', slug: 'russian', code: 'ru', label: 'Русский' },
    sr: { name: 'Serbian', slug: 'serbian', code: 'sr', label: 'Српски' },
    sk: { name: 'Slovak', slug: 'slovak', code: 'sk', label: 'Slovenčina' },
    sl: {
        name: 'Slovenian',
        slug: 'slovenian',
        code: 'sl',
        label: 'Slovenščina',
    },
    es: { name: 'Spanish', slug: 'spanish', code: 'es', label: 'Español' },
    sv: { name: 'Swedish', slug: 'swedish', code: 'sv', label: 'Svenska' },
    th: { name: 'Thai', slug: 'thai', code: 'th', label: 'ไทย' },
    tr: { name: 'Turkish', slug: 'turkish', code: 'tr', label: 'Türkçe' },
    uk: {
        name: 'Ukrainian',
        slug: 'ukrainian',
        code: 'uk',
        label: 'Українська',
    },
    ur: { name: 'Urdu', slug: 'urdu', code: 'ur', label: 'اردو' },
    vi: {
        name: 'Vietnamese',
        slug: 'vietnamese',
        code: 'vi',
        label: 'Tiếng Việt',
    },
    'zh-yue': {
        name: 'Cantonese',
        slug: 'cantonese',
        code: 'zh-yue',
        label: '廣東話',
    },
    be: {
        name: 'Belarusian',
        slug: 'belarusian',
        code: 'be',
        label: 'Беларуская',
    },
};
